import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from 'react'
import { withRouter } from 'react-router'
import Component from 'components/component'
import { DI } from 'modules'
import Login from './login'
import Mark from './mark'
import Restrictions from './restrictions'

import {
  AGREEMENT_TYPE,
} from 'components/download-slider-new/constants'

const LandindPanelDownload = props => {
  const [agreement, setAgreement] = useState()
  const [agreed, setAgreed] = useState(false)

  const {
    user: { activeVodAgreements },
    entity: video,
  } = props

  const [downloading, setDownloading] = useState({
    mp4: false,
    mxf: false,
  })

  useEffect(() => {
    loadAgreements(props.entity.inner_id, 'vod')
  }, [])

  useEffect(() => {
    if (activeVodAgreements.payload.length > 0) {
      const agreementLandingTrial = activeVodAgreements.payload.find(
        a => a.agreement_type === AGREEMENT_TYPE.LANDING_TRIAL
      )
      if (!agreementLandingTrial) return

      props.actions.videos.getAvailableFormats(video.inner_id, {
        agreement_id: agreementLandingTrial.id,
      })

      setAgreement(agreementLandingTrial)
    }
  }, [activeVodAgreements.payload])

  const loadAgreements = async (id, type) => {
    try {
      await props.actions.user.getActiveAgreements({
        content_id: id,
        content_type: type,
      })
    } catch (e) {
      console.error(e)
    }
  }
  const { user, entity } = props
  const { restrictions } = entity
  const showRestrictions = Boolean(entity.restrictions)
  const downloadableEnabled = entity.downloadable === 'enabled'
  const canDownload = (!showRestrictions || showRestrictions && agreed) &&
    props.entity?.id && agreement?.id && agreement.status === 'active'

  const availableFormats = useMemo(() => {
    if (
      props.videos.availableFormats.payload &&
      props.videos.availableFormats.payload.clean
    ) {
      return props.videos.availableFormats.payload.clean
        .filter(
          f =>
            f.extension === 'mxf' ||
            (f.extension === 'mp4' && f.quality === 'full_hd')
        )
        .reduce((a, c) => {
          return { ...a, [c.extension]: c }
        }, {})
    }
    return {}
  }, [props.videos.availableFormats])

  const onDownload = useCallback(
    (format) => () => {
      const params = {
        repeated: false,
        agreement_id: agreement.id,
        project_id: video.inner_id,
        project_slug: video.id,
        download_to_sftp: false,
        video_format: {
          quality: format.quality,
          extension: format.extension,
          brand_position: 'without_brand',
          file_type: format.file_type,
        },
      }

      setDownloading({ ...downloading, [format.extension]: true })

      props.actions.videos.downloadVideo(params).then(({ body }) => {
        if (!body.exist) {
          props.actions.notifications.createNotification({
            type: 'error',
            children:
              props.common.strings['page.video.landing.download.not_exist'],
          })
        } else {
          props.onDownload()
        }

        setDownloading({ ...downloading, [format.extension]: false })
      })
    },
    [agreement]
  )

  return (
    <div className="live-column">
      <div className="live-block__show">
        {entity.limit_type === 'pool' && (
          <Mark
            text={`Pool ${props.common.strings['page.lives.view.pool_description']}`}
            tooltip={props.common.strings['page.video.left.pool.info']}
          />
        )}
        {entity.free_access && (
          <Mark
            text={`Free ${props.common.strings['page.lives.view.free_description']}`}
            tooltip={props.common.strings['page.video.left.free.info']}
          />
        )}
        {showRestrictions && (<div className="live-subblock">
          <Restrictions
            restrictions={restrictions}
            downloadableEnabled={downloadableEnabled}
            agreed={agreed}
            onChange={ev => setAgreed(ev.target.checked)}
            user={user}
          />
        </div>)}
        <div className="live-subblock">
          {downloadableEnabled && (
            <Fragment>
              {user.isSignedIn ? (
                <div
                  className={Component.classList(
                    'live-download',
                    !showRestrictions && 'live-download--not-padded'
                  )}
                >
                  <button
                    disabled={!canDownload || !availableFormats.mp4 || downloading.mp4}
                    type="button"
                    className="button"
                    onClick={onDownload(availableFormats.mp4)}
                    data-action-name="open download slider"
                  >
                    {props.common.strings['page.video.landing.download.mp4']}
                  </button>

                  <button
                    disabled={!canDownload || !availableFormats.mxf || downloading.mxf}
                    type="button"
                    className="button"
                    onClick={onDownload(availableFormats.mxf)}
                  >
                    {props.common.strings['page.video.landing.download.mxf']}
                  </button>
                </div>
              ) : (
                <Login withRestrictions={!!restrictions} buttonText={props.common.strings['page.video.left.signin.download']} />
              )}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

export default DI(['common', 'user', 'videos', 'notifications'])(
  withRouter(LandindPanelDownload)
)
